<!--
 * @Description: 项目配置人员
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-25 14:49:47
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-30 13:53:55
 -->
<template>
  <div class="projectPersonnel">
    <div class="title">
      累计完成服务案件 <span class="value">{{total}}</span> 起
    </div>
    <div class="header">
      <span>时间</span>
      <span>地点</span>
      <span>数量</span>
    </div>
    <div class="itemContainer">
      <div class="item" v-for="(item, index) in list" :key="index">
        <el-tooltip class="time" effect="light" :content="item.statisticDate" placement="top">
          <span class="time">{{item.statisticDate}}</span>
        </el-tooltip>
        <el-tooltip class="position" effect="light" :content="item.name" placement="top">
          <span class="position">{{item.name}}</span>
        </el-tooltip>
        <span class="count">{{item.caseNum}}</span>
      </div>
      <div class="loadMore" @click="loadMore" v-if="pageNo < pages">加载更多</div>
    </div>
  </div>
</template>

<script>
import { timestampFormat } from '@/utils/timestampFormat'
export default {
  name: 'projectPersonnel',
  components: {
  },
  data () {
    return {
      pageNo: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      list: [],
    }
  },
  methods: {
    /**
     * @description                   获取数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/operation/completeServiceCase', {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
        .then(res => {
          if (res.code === 0) {
            let list = res.data.list
            list.map(item => {
              item.statisticDate = timestampFormat('YYYY-mm-dd HH:MM:SS', new Date(item.statisticDate))
            })
            this.list = this.list.concat(list)
            this.pageNo = parseFloat(res.data.pageNo)
            this.total = parseFloat(res.data.total)
            this.pages = Math.ceil(parseFloat(res.data.total) / this.pageSize)
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   加载更多
     * @return {undefied}             无返回值
     */
    loadMore () {
      this.pageNo = this.pageNo + 1
      this.getData()
    },
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .projectPersonnel {
    width: 80%;
    height: calc(40% - 3.5vh);
    margin-left: 8%;
    background: url('/static/img/layout/maintenance.png');
    background-size: 100% 100%;
    margin-top: 15vh;
    padding: 3.5vh 0 0 0;
    .title {
      width: 70%;
      margin-left: 15%;
      text-align: center;
      font-size: 1.6vh;
      color: #dedede;
      margin-bottom: 2vh;
      .value {
        font-size: 2vh;
        color: #e4ee0c;
        font-weight: bold;
      }
    }
    .header {
      width: 70%;
      margin-left: 15%;
      display: flex;
      justify-content: space-around;
      background: #1e5052;
      color: #fffefe;
      font-size: 1.4vh;
      padding: 0.5vh 0;
      >span {
        text-align: center;
      }
      >span:nth-of-type(1) {
        display: inline-block;
        width: 40%;
      }
      >span:nth-of-type(2) {
        display: inline-block;
        width: 30%;
      }
    }
    .itemContainer {
      width: 100%;
      height: 60%;
      overflow-y: scroll;
      .item {
        width: 70%;
        margin-left: 15%;
        display: flex;
        justify-content: space-around;
        padding: 0.8vh 0;
        >span {
          text-align: center;
          color: #e8e8e8;
          font-size: 1.4vh;
        }
        >span:nth-of-type(1) {
          display: inline-block;
          width: 40%;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        >span:nth-of-type(2) {
          display: inline-block;
          width: 30%;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        >span:nth-of-type(3) {
          text-align: center;
          display: inline-block;
          background: #d1730a;
          padding: 0.1vh 0.8vh;
          border-radius: 1vh;
        }
      }
      .loadMore {
        font-size: 1.5vh;
        cursor: pointer;
        text-align: center;
        color: #51afee;
      }
    }
  }
</style>
